import React from 'react';
import PendingPreAssessments from './PendingPreAssessments';

export default function PendingPostAssessments() {
  return <PendingPreAssessments title="Pending Post Assessments" type="post" />;
}
